import { render, staticRenderFns } from "./afterSubmitCertificate.vue?vue&type=template&id=18898166&scoped=true"
import script from "./afterSubmitCertificate.vue?vue&type=script&lang=js"
export * from "./afterSubmitCertificate.vue?vue&type=script&lang=js"
import style0 from "./afterSubmitCertificate.vue?vue&type=style&index=0&id=18898166&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18898166",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18898166')) {
      api.createRecord('18898166', component.options)
    } else {
      api.reload('18898166', component.options)
    }
    module.hot.accept("./afterSubmitCertificate.vue?vue&type=template&id=18898166&scoped=true", function () {
      api.rerender('18898166', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ordercenter/components/afterSubmitCertificate.vue"
export default component.exports